import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { api, UserSettings } from '../lib/api';

export function useSettings() {
  const queryClient = useQueryClient();

  const { data: settings, isLoading, error } = useQuery({
    queryKey: ['settings'],
    queryFn: api.getSettings,
    staleTime: 30 * 1000, // 30 seconds
  });

  const updateMutation = useMutation({
    mutationFn: (newSettings: Partial<UserSettings>) => api.updateSettings(newSettings),
    onSuccess: (data) => {
      queryClient.setQueryData(['settings'], data);
    },
  });

  const updateSettings = (newSettings: Partial<UserSettings>) => {
    return updateMutation.mutateAsync(newSettings);
  };

  return {
    settings,
    isLoading,
    error,
    updateSettings,
    isUpdating: updateMutation.isPending,
    updateError: updateMutation.error,
  };
}
